import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ApexPage = lazy(() => import('../pages/apex/page'));
const DpdPage = lazy(() => import('../pages/dpd/page'));
const ArchitecteWebPage = lazy(() => import('../pages/architecte-web/page'));
const StudioNewPage = lazy(() => import('../pages/studio-new/page'));
const UrgencePage = lazy(() => import('../pages/urgence/page'));
const PartenairesPage = lazy(() => import('../pages/partenaires/page'));
const SenegalPage = lazy(() => import('../pages/senegal/page'));
const EquipePage = lazy(() => import('../pages/equipe/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const GaleriePage = lazy(() => import('../pages/galerie/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/apex',
    element: <ApexPage />,
  },
  {
    path: '/dpd',
    element: <DpdPage />,
  },
  {
    path: '/architecte-web',
    element: <ArchitecteWebPage />,
  },
  {
    path: '/studio-new',
    element: <StudioNewPage />,
  },
  {
    path: '/urgence',
    element: <UrgencePage />,
  },
  {
    path: '/partenaires',
    element: <PartenairesPage />,
  },
  {
    path: '/senegal',
    element: <SenegalPage />,
  },
  {
    path: '/equipe',
    element: <EquipePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/galerie',
    element: <GaleriePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
